export const EVENTS = {
  ANIMATION_START: 'elf:animation-start',
  ANIMATION_END: 'elf:animation-end',
  STATE_CHANGE: 'elf:state-change',
};

export const SOUND_DELAY = {
  teeth: 800,
  cream: 500,
  mask: 500,
  foam: 500,
  patches: 300,
  perfume: 0,
  creamFluid: 300,
  serumFace: 150,
  creamEyes: 200,
  perfumeBirkholz: 0,
  beforeBeauty: 300,
};

export const roomLayersWeights = {
  _defaultWeight: Number.MAX_VALUE,
  floor: 1,
  wall: 2,
  carpet: 3,
};
